/* globals Sentry */
import * as Sentry from '@sentry/browser';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import DefaultError, { ErrorWindow } from './DefaultError';

Sentry.init({ dsn: RAVEN_CONFIG });

export const fireSentryException = (error, errorInfo) => {
	console.error(error);
	if (errorInfo) {
		Sentry.configureScope((scope) => {
			Object.keys(errorInfo).forEach((key) => {
				scope.setExtra(key,
					errorInfo[key]);
			});
		});
	}
	const patientId = get(window,
		'Yoderm.data.patient.id',
		'');
	if (patientId) {
		Sentry.setUser({ id: patientId });
	}

	Sentry.captureException(error);
}

export default class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: false,
			errorInfo: {},
			env: 'prod',
		};
	}

	componentDidMount() {
		const { host } = window.location
		if (host === 'app.locals' || host === 'yoderm.accessderm.co') {
			this.setState({
				env: 'stg',
			})
		}
	}

	componentDidCatch(error, errorInfo) {
		this.setState({
			error,
			errorInfo,
		});
		fireSentryException(error,
			errorInfo)
	}

	render() {
		const {
			children, handleError, errorWindow, preserveChildren, hideOnError,
		} = this.props;
		const {
			error, errorInfo, env,
		} = this.state;
		if (error) {
			if (env !== 'prod') {
				console.log('Error logged to sentry:\n',
					errorInfo)
			}
			if (handleError) {
				return handleError()
			} else if (errorWindow) {
				return <ErrorWindow />
			} else if (preserveChildren) {
				return (
					<>
						{children}
					</>
				)
			} else if (hideOnError) {
				return null;
			}
			return <DefaultError />
		}
		return children;
	}
}

ErrorBoundary.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array,
	]),
};
